import React, { useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import Table from "../../../../components/TableComp";
import HyperDatepicker from "components/Datepicker";
import { get } from "helpers";
import { IOrderBy } from "../../../../types";
import { getCicloAtual } from "utils/getCicloAtualPulseSentimentos";
import { ColunaData } from "./TableColumnsVerbalizacao";
import { IResposta } from "./Dashboard";

interface IListagemVerbalizacaoProps {
  title: string;
}

interface VerbalizacaoCellProps {
  value?: string | null;
}

const VerbalizacaoCell = ({ value }: VerbalizacaoCellProps) => {
  const [showModal, setShowModal] = useState(false);

  const verbalizacao = value?.trim() || "";

  const preview =
    verbalizacao.length > 120
      ? `${verbalizacao.substring(0, 120)}...`
      : verbalizacao;

  return (
    <>
      <div
        className="d-flex align-items-center gap-2"
        style={{
          minWidth: 0,
          maxWidth: "100%",
        }}
      >
        <div
          style={{
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
          title={verbalizacao}
        >
          {preview || "-"}
        </div>

        {verbalizacao && (
          <Button
            variant="link"
            size="sm"
            className="p-0 text-nowrap"
            onClick={() => setShowModal(true)}
          >
            <i className="mdi mdi-eye"></i>
          </Button>
        )}
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Verbalização</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              lineHeight: 1.6,
              maxHeight: "60vh",
              overflowY: "auto",
            }}
          >
            {verbalizacao || "Nenhuma verbalização informada."}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const ListagemVerbalizacao = ({ title }: IListagemVerbalizacaoProps) => {
  const [tableData, setTableData] = useState<IResposta[] | null>(null);
  const [pageIndexController, setPageIndexController] = useState(0);
  const [order, setOrder] = useState<IOrderBy[]>([]);

  const [startDate, setStartDate] = useState(
    getCicloAtual().sextaInicioCiclo
  );
  const [endDate, setEndDate] = useState(
    getCicloAtual().quintaFechaCiclo
  );

  useEffect(() => {
    async function fetchData() {
      if (startDate && endDate && endDate < startDate) return;

      const response = await get("/autoavaliacao-resposta/verbalizacao", {
        data_inicio: startDate.toISOString(),
        data_fim: endDate.toISOString(),
      });

      setTableData(response.data);
    }

    fetchData();
  }, [pageIndexController, order, startDate, endDate]);

  return (
    <Card
      style={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
      }}
    >
      <Card.Header>
        <Card.Title className="mb-0">{title}</Card.Title>
      </Card.Header>

      <Card.Body
      style={{
        minHeight: "20vw",
      }}>
        <Row className="mb-3">
          <Col className="d-flex align-items-end gap-2 flex-wrap">
            <div style={{ zIndex: 6 }}>
              <label className="form-label">Data Início</label>

              <HyperDatepicker
                hideAddon
                value={startDate}
                onChange={setStartDate}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div style={{ zIndex: 4 }}>
              <label className="form-label">Data Fim</label>

              <HyperDatepicker
                hideAddon
                value={endDate}
                onChange={setEndDate}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </Col>
        </Row>

        <div
          style={{
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <Table
            columns={[
              {
                Header: "Colaborador",
                accessor: "usuario",
                sort: true,
                Cell: ({ row }) => {
                  return (
                    <div
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      {row.original?.usuario?.colaborador?.apelido || "-"}
                    </div>
                  );
                },
              },
              {
                Header: "Descrição",
                accessor: "observacao",
                sort: false,
                Cell: ({ row }) => (
                  <VerbalizacaoCell
                    value={row.original?.observacao}
                  />
                ),
              },
              {
                Header: "Data Preenchimento",
                accessor: "created_at",
                sort: true,
                className: "text-center",
                Cell: ColunaData,
              },
            ]}
            data={tableData ?? []}
            tableClass="table-striped"
            pagination={false}
            isSortable={false}
            setOrder={setOrder}
            searchValue=""
            theadClass="text-center"
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default ListagemVerbalizacao;